import { Component, OnInit, ViewChild } from '@angular/core';
import { GridOptions, ColDef, ColGroupDef } from 'ag-grid-community';
import { AuthService } from 'src/app/modules/core/services/auth/auth.service';
import { AgGridActionsRendererComponent } from 'src/app/modules/shared/components/ag-grid-action-renderer/ag-grid-action-renderer.component';
import { AgGridActionsWrapperComponent } from 'src/app/modules/shared/components/ag-grid-actions-wrapper/ag-grid-actions-wrapper.component';
import { AgGridWrapperComponent } from 'src/app/modules/shared/components/ag-grid-wrapper/ag-grid-wrapper.component';
import { IPurchaseRequest, TypeCellRenderedMethod } from 'src/app/modules/shared/models';
import { PrInitiatorService } from '../../services/pr-initiator.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-bulk-upload-history',
  templateUrl: './bulk-upload-history.component.html',
  styleUrls: ['./bulk-upload-history.component.scss']
})
export class BulkUploadHistoryComponent implements OnInit {

   /******** Ag Grid Variables **********/
   public gridApi: any;
   public gridColumnApi: any;
   public pr_Status: any = '';
 
 
   public frameworkComponents: any;
   public context: any;
   public vendorName = [{name: 'ALL'},{name: 'PROCESSED'},{name: 'FAILED'}];
   public selectedStatus: any;

   public gridOptions: GridOptions = {
     defaultColDef: {
       editable: false,
       sortable: true,
       flex: 1,
       minWidth: 250,
       filter: true,
       resizable: true,
       autoHeight: true,
       wrapText: true
     },
     suppressContextMenu: false,
     suppressMenuHide: false,
     sideBar: "true",
     rowGroupPanelShow: 'always',
     headerHeight: 40,
     pagination: true,
     paginationPageSize: 25,
     rowSelection: 'multiple',
     suppressCellSelection: true,
     overlayNoRowsTemplate: 'No results found.'
   }
   public columnDefs: (ColDef | ColGroupDef)[] = [];
   public purchaseRequests: Array<IPurchaseRequest> = [];
   public activePurchaseRequests: Array<IPurchaseRequest> = [];
   public selectedRows: any = [];
   public  userId !: any 
   @ViewChild('grid') grid!: AgGridWrapperComponent;
   public customCellRendererOptions !: TypeCellRenderedMethod<any, string | null>;
 
  constructor(private _authservice:AuthService,private _prInitatorService:PrInitiatorService,
    private _toastr : ToastrService
  ) {
    this.frameworkComponents = {
      AgGridActionsWrapperComponent: AgGridActionsWrapperComponent,
      AgGridActionsRendererComponent: AgGridActionsRendererComponent
    };
    this.context = { componentParent: this }; 
   }

  ngOnInit(): void {
    this.userId = this._authservice.getUserId();
    this.setRowData()
    this.setColumnDef();
  }

  public setRowData(){
    this._prInitatorService.fetchBulkPRHistory().subscribe((res:any)=>{
      this.purchaseRequests = res?.data;
      console.log(this.purchaseRequests)
    })
  }

  public convertToPR(){
    this._prInitatorService.convertToPR().subscribe((res:any)=>{
      if(res.status == 200){
        this._toastr.success(res.message);
        this.setRowData();
      }
    })
  }

  public onRowSelect(event: any) {
    const selectedRows = event.api.getSelectedRows();
    this.selectedRows = selectedRows;
  }

  public onGridReady(params: any) {
    this.grid.autoSizeAll(false);
  }

  public setColumnDef() {
    const coldefs = [
      { headerName: 'Excel Seq No', field: 'excel_seq', resizable: true, filter: true},
      { headerName: 'PR Description', field: 'pr_description', resizable: true, filter: true},
      { headerName: 'Item Category', field: 'item_category', resizable: true, filter: true},
      { headerName: 'Material Code/Service Code', field: 'material_code', resizable: true, filter: true},
      { headerName: 'Item Desc', field: 'item_desc', resizable: true, filter: true},
      { headerName: 'Short Description', field: 'short_text', resizable: true, filter: true},
      { headerName: 'Material Group', field: 'matl_group', resizable: true, filter: true },
      { headerName: 'Service Category', field: 'service_category', resizable: true, filter: true},
      { headerName: 'ESN', field: 'esn_id', resizable: true, filter: true },
      { headerName: 'Quantity', field: 'quantity', resizable: true, filter: true },
      { headerName: 'Ordering Unit', field: 'ordering_unit', resizable: true, filter: true },
      { headerName: 'Price', field: 'price', resizable: true, filter: true },
      { headerName: 'Currency', field: 'currency', resizable: true, filter: true },
      { headerName: 'Delivery Date', field: 'delivery_date', resizable: true, filter: true },
      { headerName: 'warranties', field: 'warranties', resizable: true, filter: true },
      { headerName: 'HSN/SAC', field: 'hsn_sac'},
      { headerName: 'PO Text', field: 'po_text', resizable: true, filter: true},
      { headerName: 'Account Assignment Category', field: 'acc_assignment_category', resizable: true, filter: true },
      { headerName: 'Account Assignment Value', field: 'acc_assignment_value', resizable: true, filter: true },
      { headerName: 'GL Account', field: 'gl_account', resizable: true, filter: true },
      { headerName: 'Sales Order No', field: 'sales_order_no', resizable: true, filter: true },
      { headerName: 'Cost Center', field: 'cost_center', resizable: true, filter: true },
      { headerName: 'Vendor Name', field: 'vendor_name' },
      { headerName: 'Vendor Code', field: 'vendor_code' },
      { headerName: 'Employee Code', field: 'employee_code', minWidth: 5 },
      { headerName: 'Vendor Location', field: 'vendor_location' },
      { headerName: 'Purchasing Organization', field: 'purchasing_organization', minWidth: 5 },
      { headerName: 'Company Code', field: 'company_code', minWidth: 5 },
      { headerName: 'Purchasing Group', field: 'purchasing_group', minWidth: 5 },
      { headerName: 'plant Code', field: 'plant_code', resizable: true, filter: true },
      { headerName: 'Division', field: 'division', resizable: true, filter: true },
      { headerName: 'ECCN Number', field: 'eccn_number', minWidth: 5 },
      { headerName: 'File Name', field: 'fileName' },
      { headerName: 'Delivery Address Title', field: 'delivery_address_title' },
      { headerName: 'Delivery address name', field: 'delivery_address_name', minWidth: 5 },
      { headerName: 'Delivery address name_1', field: 'delivery_address_name_1' },
      { headerName: 'Street or house number', field: 'street_or_house_number', minWidth: 5 },
      { headerName: 'district', field: 'district', minWidth: 5 },
      { headerName: 'Postal code', field: 'postal_code', minWidth: 5 },
      { headerName: 'city', field: 'city', minWidth: 5 },
      { headerName: 'country', field: 'country', resizable: true, filter: true },
      { headerName: 'region', field: 'region', resizable: true, filter: true },
      { headerName: 'Uploaded By', field: 'createdBy', resizable: true, filter: true },
      { headerName: 'On Behalf of', field: 'behalf_of', resizable: true, filter: true },
      { headerName: 'dateTime', field: 'dateTime', resizable: true, filter: true },
      { headerName: 'processing status', field: 'processing_status', minWidth: 5 },
      { headerName: 'error remarks', field: 'error_remarks', minWidth: 5 },
    ];
    this.columnDefs = coldefs;
  }

  onClickVendorName(e: any){
    this.selectedStatus = e.target.value
  }

  clearThePr(){
    this._prInitatorService.clearPr({"status":this.selectedStatus}).subscribe((res:any)=>{
      if(res.status == 200){
        this.setRowData()
      }
    })
  }
}
